import { Component } from '@angular/core';
import { ProductFacetNavigationComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-product-facet-navigation',
  templateUrl: './product-facet-navigation.component.html',
  styleUrl: './product-facet-navigation.component.scss',
  standalone: false,
})
export class CustomProductFacetNavigationComponent extends ProductFacetNavigationComponent {}
